export interface SalesDiscountProductType {
  id: string;
  productTypeId: string;
  productTypeDescription: string;
  salesDiscountId: string;
  salesDiscountKey: string;
  salesDiscountDescription: string;
  discountRate: number;
}
